import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	moreMenuLabel: {
		id: 'navigation.global-side-navigation.more-menu.label',
		description:
			'Label on More menu button in the side navigation. Shows a popout with items that are hidden from the main navigation.',
		defaultMessage: 'More',
	},
});
